module.exports = __webpack_public_path__ + "img/image-mark-shuttleworth.41a79655.webp";